<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-before: always;"></div>
<p class="P_Norm-Center__And__Page_Break" id="auto_bookmark_toc_1"><span>À Michelle et Maite, qui m’ont tenu compagnie pendant que j’écrivais ce roman et n’ont cessé d’encourager Mace.</span></p>
<p class="P_Norm-Center"><span>À Jules, qui m’a dit : « Non, tu ne t’es pas trompée. » J’espère qu’elle aura raison cette fois, contrairement au jour où elle m’a affirmé que nous ne risquions rien à finir le gâteau.</span></p>
<p class="P_Norm-Center"><span>Ce livre surtout est dédié à Yoshiko, ma chatte bien-aimée, qui a passé sa vie à lutter stoïquement contre les rayons de soleil, les frottements de ventre et le chien quand elle considérait le temps venu de lui rabattre le caquet. Tu vas terriblement me manquer, ma minette. Mon ordinateur n’est plus le même sans toi couchée dessus et mon cœur n’oubliera jamais tes ronronnements.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0003.vue?b79809d4